/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IntegrationEventPccPatient } from './IntegrationEventPccPatient';
import {
    IntegrationEventPccPatientFromJSON,
    IntegrationEventPccPatientFromJSONTyped,
    IntegrationEventPccPatientToJSON,
} from './IntegrationEventPccPatient';
import type { IntegrationEventTooltips } from './IntegrationEventTooltips';
import {
    IntegrationEventTooltipsFromJSON,
    IntegrationEventTooltipsFromJSONTyped,
    IntegrationEventTooltipsToJSON,
} from './IntegrationEventTooltips';

/**
 * 
 * @export
 * @interface IntegrationEvent
 */
export interface IntegrationEvent {
    /**
     * 
     * @type {number}
     * @memberof IntegrationEvent
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IntegrationEvent
     */
    facility_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IntegrationEvent
     */
    integration_patient_id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IntegrationEvent
     */
    actioned?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IntegrationEvent
     */
    integration?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationEvent
     */
    event_type?: string;
    /**
     * 
     * @type {object}
     * @memberof IntegrationEvent
     */
    event_payload?: object;
    /**
     * 
     * @type {object}
     * @memberof IntegrationEvent
     */
    fetched_data?: object;
    /**
     * 
     * @type {string}
     * @memberof IntegrationEvent
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationEvent
     */
    updatedAt?: string;
    /**
     * 
     * @type {IntegrationEventTooltips}
     * @memberof IntegrationEvent
     */
    tooltips?: IntegrationEventTooltips;
    /**
     * 
     * @type {IntegrationEventPccPatient}
     * @memberof IntegrationEvent
     */
    pcc_patient?: IntegrationEventPccPatient;
}

/**
 * Check if a given object implements the IntegrationEvent interface.
 */
export function instanceOfIntegrationEvent(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function IntegrationEventFromJSON(json: any): IntegrationEvent {
    return IntegrationEventFromJSONTyped(json, false);
}

export function IntegrationEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationEvent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'facility_id': !exists(json, 'facility_id') ? undefined : json['facility_id'],
        'integration_patient_id': !exists(json, 'integration_patient_id') ? undefined : json['integration_patient_id'],
        'actioned': !exists(json, 'actioned') ? undefined : json['actioned'],
        'integration': !exists(json, 'integration') ? undefined : json['integration'],
        'event_type': !exists(json, 'event_type') ? undefined : json['event_type'],
        'event_payload': !exists(json, 'event_payload') ? undefined : json['event_payload'],
        'fetched_data': !exists(json, 'fetched_data') ? undefined : json['fetched_data'],
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
        'tooltips': !exists(json, 'tooltips') ? undefined : IntegrationEventTooltipsFromJSON(json['tooltips']),
        'pcc_patient': !exists(json, 'pcc_patient') ? undefined : IntegrationEventPccPatientFromJSON(json['pcc_patient']),
    };
}

export function IntegrationEventToJSON(value?: IntegrationEvent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'facility_id': value.facility_id,
        'integration_patient_id': value.integration_patient_id,
        'actioned': value.actioned,
        'integration': value.integration,
        'event_type': value.event_type,
        'event_payload': value.event_payload,
        'fetched_data': value.fetched_data,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'tooltips': IntegrationEventTooltipsToJSON(value.tooltips),
        'pcc_patient': IntegrationEventPccPatientToJSON(value.pcc_patient),
    };
}

